export default "__VITE_ASSET__CdBDYjfH__"